import React, { useState, useEffect, useRef } from 'react';
import { Button, Input } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { replaceState, setIdentity } from '../redux/actions';

const PeerConnection = (props) => {
  let [peer, setPeer] = useState({});
  let [partnerPeerId, setpartnerPeerId] = useState(null);
  let partnerRef = useRef(partnerPeerId);
  const startGame = (peer, partnerPeerId, myId, partnerId) => {
    console.log('peerAndar', peer, peer.id, partnerPeerId)
    var conn =  peer.connect(partnerPeerId);
    props.setIdentity(myId, peer.id, 'SET_MY_IDENTITY');
    props.setIdentity(partnerId, partnerPeerId, 'SET_PARTNER_IDENTITY');
    window.conn = conn;
  }
  useEffect(() => {
    partnerRef.current = partnerPeerId;
  });
  useEffect(() => {
    const peer = new window.Peer();
    peer.on('open', function(id) {
      setPeer(peer);
    });
    peer.on('connection', (conn) => {
      if (!partnerRef.current)
        startGame(peer,conn.peer, 'O', 'X')
      conn.on('data', (data) => {
        props.replaceState(data)
      });
    })
  }, []);
  // const { partnerIdentity } = props;
  // useEffect(() => {
  //   console.log('pp',partnerIdentity.id)
  //   if (peer && peer.on) {
  //     peer.on('connection', (conn) => {
  //       console.log('connect again & again')
  //       if (!partnerIdentity.id)
  //         startGame(peer,conn.peer, 'O', 'X')
  //     });
  //     return () => (peer.off('connection', (conn) => {
  //       console.log('disconnect again & again')
  //       if (!partnerIdentity.id)
  //         startGame(peer,conn.peer, 'O', 'X')
  //     }));
  //   }
    
  // }, [peer, partnerIdentity])
  if (props.partnerIdentity.id) {
    return props.children;
  }
  return (
    <div>
        Your peer id <h2>{peer.id}</h2>
      <div>
        <Input className='u-margin' placeholder='Partner peer id' onChange ={(ele, {value}) => setpartnerPeerId(value)}/>
        <Button className='u-margin' onClick={() => startGame(peer,partnerPeerId, 'X', 'O')}>Connect</Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    presentState: {
      gridSize: state.gridSize,
      streak: state.streak,
      activePlayer: state.activePlayer,
      grid: state.grid,
      gameWinner: state.gameWinner,
      totalTurns: state.totalTurns
    },
    ...state,
    partnerIdentity: state.partnerIdentity
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    replaceState: (payload) => dispatch(replaceState(payload)),
    setIdentity: (id, peerId, type) => dispatch(setIdentity(id, peerId, type))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(PeerConnection);